function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "v");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 15.4763,
  y: 72.32086,
  width: 9.68149,
  height: 9.68149
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 32.58414,
  y: 72.32086,
  width: 9.68157,
  height: 9.68149
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 15.4763,
  y: 89.78457,
  width: 9.68149,
  height: 9.68149
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 32.58414,
  y: 89.78457,
  width: 9.68157,
  height: 9.68149
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 37.28273,
  y: 38.33033,
  width: 9.68157,
  height: 9.68157
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 54.39065,
  y: 38.33033,
  width: 9.68149,
  height: 9.68157
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M54.56153,53.50719H29.88033V32.84007L71.39251,17.06335V44.3105h-.16506V98.55074a9.62494,9.62494,0,0,1,1.43533-.87648c1.46083-.72406,3.3408-1.537,5.3224-2.33732V44.3105L77.97254,7.52374,23.30038,28.30522V51.30966H.98186v69.16582h64.9994v-.07621c0-.21592.05078-3.04866.26671-6.50374H54.56153Zm-4.38234,60.38834H7.56181V57.88961H50.17919Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M125.92054,105.8632a5.80889,5.80889,0,0,0-3.12736-4.21271c-5.43886-2.71133-17.3754-6.718-17.3754-6.718H104.408l-3.26621,4.35761,3.06215,21.18619h22.81418A126.32884,126.32884,0,0,0,125.92054,105.8632Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M109.28967,82.32581l1.64365-8.47209A11.34159,11.34159,0,0,0,99.69695,60.98378H97.74457A11.34158,11.34158,0,0,0,86.50828,73.85372l1.64365,8.47209a10.767,10.767,0,0,0,21.13773,0Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M92.02374,94.93246s-11.93647,4.00671-17.37532,6.718A5.809,5.809,0,0,0,71.521,105.8632a126.34044,126.34044,0,0,0-1.09752,14.61306H93.23764l3.06215-21.18619-3.26621-4.35761Z"
});

var SvgCompany = function SvgCompany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Company.40ae0b1f.svg";
export { ForwardRef as ReactComponent };